import { api } from './client';
import { PAGINATION } from '@/lib/constants';
import type {
  AccountResponse,
  Page,
  PageParams,
  RunSummary,
  SchedulerStatusResponse,
  TriggerRollupDailyRequest,
  TriggerRollupHourlyRequest,
  TriggerRollupResult,
  TriggerViralDetectionResult,
} from '@/types/api';
import type { SchedulerRunType } from '@/types/enums';

export interface SchedulerRunsParams extends PageParams {
  type?: SchedulerRunType;
}

export const schedulerApi = {
  async status(): Promise<SchedulerStatusResponse> {
    const res = await api.get<SchedulerStatusResponse>('/scheduler/status');
    return res.data;
  },

  async runs(params: SchedulerRunsParams = {}): Promise<Page<RunSummary>> {
    const res = await api.get<Page<RunSummary>>('/scheduler/runs', {
      params: {
        page: params.page ?? 0,
        size: params.size ?? PAGINATION.schedulerRunsPageSize,
        sort: params.sort ?? 'startedAt,desc',
        ...(params.type ? { type: params.type } : {}),
      },
    });
    return res.data;
  },

  async accountsHealth(): Promise<AccountResponse[]> {
    const res = await api.get<AccountResponse[]>('/scheduler/accounts-health');
    return res.data;
  },

  async triggerCycle(): Promise<RunSummary> {
    const res = await api.post<RunSummary>('/scheduler/trigger-cycle');
    return res.data;
  },

  async triggerProfileRefresh(): Promise<RunSummary> {
    const res = await api.post<RunSummary>('/scheduler/trigger-profile-refresh');
    return res.data;
  },

  async triggerRollupHourly(body: TriggerRollupHourlyRequest = {}): Promise<TriggerRollupResult> {
    const res = await api.post<TriggerRollupResult>('/scheduler/trigger-rollup-hourly', null, {
      params: body.hour ? { hour: body.hour } : undefined,
    });
    return res.data;
  },

  async triggerRollupDaily(body: TriggerRollupDailyRequest = {}): Promise<TriggerRollupResult> {
    const res = await api.post<TriggerRollupResult>('/scheduler/trigger-rollup-daily', null, {
      params: body.date ? { date: body.date } : undefined,
    });
    return res.data;
  },

  async triggerViralDetection(): Promise<TriggerViralDetectionResult> {
    const res = await api.post<TriggerViralDetectionResult>('/scheduler/trigger-viral-detection');
    return res.data;
  },
};
